export default __webpack_public_path__ + "static/excelencia-23-event-b9e0d317ff62aa57b6aff9256717dba2.jpg";